import {connect} from 'react-redux'
import SearchTypePanel from '../components/search-page/search-type-panel'
import * as appActions from '../store/app/actions'

export default connect((state) => {
  return {
    ...state.app,
  }
}, appActions)(SearchTypePanel)



// WEBPACK FOOTER //
// ./src/containers/search-type-container.js